import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpdateDivision } from "~pages/Divisions/types/upsertDivision.ts";
import type { DivisionResponse } from "~types/division.ts";

export const useUpdateDivision = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<DivisionResponse, Error, UpdateDivision>({
    mutationFn: async ({ divisionId, ...updateData }) =>
      await request<DivisionResponse>(`${sport}/o/${organizationId}/divisions/${divisionId}`, {
        method: "PUT",
        body: updateData,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["divisions"] });
    },
  });
};
